import { BusinessOnboardingDetails } from '@nemuru-eng/js-api-client';

import { BusinessFinancialDetailsEditDialog } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessFinancialDetails/components/BusinessFinancialDetailsEditDialog';
import { BusinessFinancialDetailsForm } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessFinancialDetails/components/BusinessFinancialDetailsForm';
import { useBusinessDetailsActions } from '@/components/modules/KYC/KYCLoan/BusinessKYC/hooks/useBusinessDetailsActions';
import { useBusinessKyc } from '@/components/modules/KYC/KYCLoan/BusinessKYC/hooks/useBusinessKyc';
import { BusinessActions } from '@/components/modules/KYC/KYCLoan/BusinessKYC/types/BusinessActions';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { PendingDataType } from '@/config/types';

interface BusinessFinancialDetailsProps {
  loanId: string;
  businessOnboarding: BusinessOnboardingDetails;
  editModeAllowed?: boolean;
}

export const BusinessFinancialDetails = ({
  loanId,
  businessOnboarding,
  editModeAllowed,
}: BusinessFinancialDetailsProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();

  const { dialogAction, toggleEditModeDialog, businessBaseActionsOptions } = useBusinessDetailsActions({
    editModeAllowed,
    businessOnboarding,
    toggleDialog,
  });

  const { setBusinessDetailsToOnboardingDetails, loading } = useBusinessKyc({ loanId });

  return (
    <SubSectionWrapper
      title={'BUSINESS_FINANCIAL_DETAILS'}
      specificActionsOptionsArray={toggleEditModeDialog ? businessBaseActionsOptions : undefined}
    >
      {!businessOnboarding.businessDetails ? (
        <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />
      ) : (
        <>
          <BusinessFinancialDetailsForm businessDetails={businessOnboarding.businessDetails} />
          {opened && dialogAction === BusinessActions.EDIT_DIALOG && (
            <BusinessFinancialDetailsEditDialog
              businessDetails={businessOnboarding}
              opened={opened}
              setOpened={setOpened}
              toggleDialog={toggleDialog}
              loading={loading}
              setBusinessDetailsToOnboardingDetails={setBusinessDetailsToOnboardingDetails}
            />
          )}
        </>
      )}
    </SubSectionWrapper>
  );
};

export enum BusinessFinancialDetailsAction {
  EDIT_DIALOG = 'edit_dialog',
}
